"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _style = require("../utils/style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n  border-radius: 50%;\n  background: ", ";\n  position: absolute;\n  left: 50%;\n  margin-top: -10px;\n  margin-left: -10px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: 0.8s;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: 0.6s;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: 0.4s;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  animation-delay: 0.2s;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  animation: ", " ", "s linear infinite;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 50px;\n  height: 50px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n       0%{\n            transform: rotate(0deg);\n        }\n        10%{\n            transform: rotate(45deg);\n        }\n        50%{\n            opacity: 1;\n            transform: rotate(160deg);\n        }\n        62%{\n            opacity: 0;\n        }\n        65%{\n            opacity: 0;\n            transform: rotate(200deg);\n        }\n        90%{\n            transform: rotate(340deg);\n        }\n        100%{\n            transform: rotate(360deg);\n        }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var load = (0, _styledComponents.keyframes)(_templateObject());

var Container = _styledComponents.default.div(_templateObject2());

var ItemDiv = _styledComponents.default.div(_templateObject3(), load, function (props) {
  return props.speed || 2;
});

var ItemDiv1 = (0, _styledComponents.default)(ItemDiv)(_templateObject4());
var ItemDiv2 = (0, _styledComponents.default)(ItemDiv)(_templateObject5());
var ItemDiv3 = (0, _styledComponents.default)(ItemDiv)(_templateObject6());
var ItemDiv4 = (0, _styledComponents.default)(ItemDiv)(_templateObject7());

var ItemSpan = _styledComponents.default.span(_templateObject8(), function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem['default'];
}, function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem['default'];
}, function (props) {
  return props.color || '#00adb5';
});

var CommonLoading = function CommonLoading(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
      speed = _ref.speed,
      color = _ref.color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  return _react.default.createElement(Container, {
    style: style,
    speed: speed,
    color: color,
    size: size
  }, _react.default.createElement(ItemDiv1, {
    speed: speed
  }, _react.default.createElement(ItemSpan, {
    color: color,
    size: size
  })), _react.default.createElement(ItemDiv2, {
    speed: speed
  }, _react.default.createElement(ItemSpan, {
    color: color,
    size: size
  })), _react.default.createElement(ItemDiv3, {
    speed: speed
  }, _react.default.createElement(ItemSpan, {
    color: color,
    size: size
  })), _react.default.createElement(ItemDiv4, {
    speed: speed
  }, _react.default.createElement(ItemSpan, {
    color: color,
    size: size
  })));
};

var _default = CommonLoading;
exports.default = _default;